import { render, staticRenderFns } from "./ConsultationPatientSelect.vue?vue&type=template&id=5119aff6&"
import script from "./ConsultationPatientSelect.vue?vue&type=script&lang=js&"
export * from "./ConsultationPatientSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports